module.exports = __webpack_public_path__ + "static/media/mx.a63d567e.svg";